module.exports = __webpack_public_path__ + "30ac8db4b8b7b37954e6c2af332bc9f2.mp3";